webpackJsonp([14091759593442],{

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colorLabels = {
	  opinion: 'red',
	  idea: 'yellow',
	  musings: 'blue'
	};
	
	var defaultColor = 'red';
	
	var colorForLabel = function colorForLabel(label) {
	  var supportedLabels = Object.keys(colorLabels);
	  if (supportedLabels.includes(label)) {
	    return colorLabels[label];
	  }
	  return defaultColor;
	};
	
	var ArticleLabel = function ArticleLabel(_ref) {
	  var label = _ref.label,
	      color = _ref.color;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Article-labels-item Article-labels-item--' + color },
	    label
	  );
	};
	
	var ArticleLabels = function (_React$Component) {
	  _inherits(ArticleLabels, _React$Component);
	
	  function ArticleLabels() {
	    _classCallCheck(this, ArticleLabels);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArticleLabels.prototype.renderLabels = function renderLabels() {
	    return this.props.labels.map(function (label, index) {
	      return _react2.default.createElement(ArticleLabel, { key: 'label-' + index, label: label, color: colorForLabel(label) });
	    });
	  };
	
	  ArticleLabels.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Article-labels' },
	      this.renderLabels()
	    );
	  };
	
	  return ArticleLabels;
	}(_react2.default.Component);
	
	exports.default = ArticleLabels;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _articleLabel = __webpack_require__(58);
	
	var _articleLabel2 = _interopRequireDefault(_articleLabel);
	
	var _para = __webpack_require__(13);
	
	var _para2 = _interopRequireDefault(_para);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleListItem = function ArticleListItem(_ref) {
	  var title = _ref.title,
	      link = _ref.link,
	      date = _ref.date,
	      target = _ref.target,
	      tags = _ref.tags;
	
	  var component = void 0;
	  if (target === '') {
	    component = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'Article-list-item', to: link, target: target },
	      _react2.default.createElement(_header2.default, { className: 'strong', text: title }),
	      _react2.default.createElement(_para2.default, { className: 'grey', text: date }),
	      _react2.default.createElement(_articleLabel2.default, { labels: tags })
	    );
	  } else {
	    component = _react2.default.createElement(
	      'a',
	      { className: 'Article-list-item', href: link, target: target },
	      _react2.default.createElement(_header2.default, { className: 'strong', text: title }),
	      _react2.default.createElement(_para2.default, { className: 'grey', text: date }),
	      _react2.default.createElement(_articleLabel2.default, { labels: tags })
	    );
	  }
	  return component;
	};
	
	exports.default = ArticleListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(9);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _layout = __webpack_require__(10);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _para = __webpack_require__(12);
	
	var _para2 = _interopRequireDefault(_para);
	
	var _para3 = __webpack_require__(13);
	
	var _para4 = _interopRequireDefault(_para3);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _superheader = __webpack_require__(16);
	
	var _superheader2 = _interopRequireDefault(_superheader);
	
	var _articleListItem = __webpack_require__(141);
	
	var _articleListItem2 = _interopRequireDefault(_articleListItem);
	
	__webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleList = function (_React$Component) {
	  _inherits(ArticleList, _React$Component);
	
	  function ArticleList() {
	    _classCallCheck(this, ArticleList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArticleList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _layout2.default,
	      { key: 'main-layout' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Product, Design & The Process'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We write about everything Product, everything from conception to execution' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://surebro.com/articles' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Product, Design & The Process' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We write about everything Product, everything from conception to execution' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png' })
	      ),
	      _react2.default.createElement(_navbar2.default, { key: 'navbar', active: 4, className: 'red' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Article-hero' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_superheader2.default, {
	                key: 'about-title',
	                className: 'text-left darkgrey About-content-title',
	                text: 'Product, Design & The Process'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_para2.default, { className: 'grey', text: 'Recent Articles' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'Article-list' },
	          _react2.default.createElement(_articleListItem2.default, {
	            title: 'How about a debt clearing sprint?',
	            link: 'articles/how-about-clearing-your-debts',
	            date: 'Jul 4th, 2018',
	            target: '',
	            tags: ['opinion', 'idea']
	          }),
	          _react2.default.createElement(_articleListItem2.default, {
	            title: 'Let\u2019s talk about MVP',
	            link: 'https://blog.surebro.com/minimal-viable-product-8fa5f24e58c8',
	            date: 'Jun 7, 2016',
	            target: '__blank',
	            tags: ['idea']
	          }),
	          _react2.default.createElement(_articleListItem2.default, {
	            title: 'What\u2019s \u201CThe box\u201D in \u201CThink outside the box\u201D?',
	            link: 'https://blog.surebro.com/what-s-the-box-in-think-outside-the-box-5373f76ccc95',
	            date: 'Jan 29th, 2016',
	            target: '__blank',
	            tags: ['musings']
	          }),
	          _react2.default.createElement(_articleListItem2.default, {
	            title: 'Burning Capital for Dummies',
	            link: 'https://blog.surebro.com/burning-capital-for-dummies-bec7831eb278',
	            date: 'Dec 20th, 2015',
	            target: '__blank',
	            tags: ['how-to']
	          })
	        )
	      )
	    );
	  };
	
	  return ArticleList;
	}(_react2.default.Component);
	
	exports.default = ArticleList;
	module.exports = exports['default'];

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-articles-index-js-0395dfd17888950a41dd.js